import '../../style/';
import './index.less';



// WEBPACK FOOTER //
// ./components/avatar/style/index.tsx